// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTextContentByIdRequestModel from '../../model/get-text-content-by-id-request-model';
import GetTextContentByIdRequestDTO from '../dto/get-text-content-by-id-request-dto';
import dtoSchema from '../schemas/get-text-content-by-id-request-schema';

export default abstract class GetTextContentByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTextContentByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetTextContentByIdRequestDTO>): GetTextContentByIdRequestModel;
  static toModel(dto: DeepPartial<GetTextContentByIdRequestDTO> | undefined | null): GetTextContentByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTextContentByIdRequestDTO> | undefined | null): GetTextContentByIdRequestModel | undefined {
    return dto ? new GetTextContentByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTextContentByIdRequestModel> | GetTextContentByIdRequestModel): GetTextContentByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetTextContentByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTextContentByIdRequestModel, can not map to GetTextContentByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
